import {
  Swiper, Navigation,
} from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const swiperContainerClass = '.js_news-box__swiper';
const swiperInstances = new Map();

function initMobileSwipers() {
  const isMobile = window.innerWidth <= breakpoints.lg;
  const sliders = document.querySelectorAll(swiperContainerClass);

  sliders.forEach((slider, index) => {
    const key = slider.dataset.swiperId || index;
    const hasInstance = swiperInstances.has(key);

    const slideCount = slider.querySelectorAll('.swiper-slide').length;

    const nextBtn = slider.querySelector('.swiper-button-next');
    const prevBtn = slider.querySelector('.swiper-button-prev');

    const setNavVisible = (visible) => {
      if (nextBtn) nextBtn.style.display = visible ? '' : 'none';
      if (prevBtn) prevBtn.style.display = visible ? '' : 'none';
    };

    if (isMobile && slideCount > 1 && !hasInstance) {
      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        loop: true,
        modules: [Navigation],
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });

      setNavVisible(true);

      swiperInstances.set(key, swiper);
    } else if (isMobile && slideCount <= 1) {
      if (hasInstance) {
        swiperInstances.get(key).destroy(true, true);
        swiperInstances.delete(key);
      }
      setNavVisible(false);
    } else if (!isMobile && hasInstance) {
      swiperInstances.get(key).destroy(true, true);
      swiperInstances.delete(key);
      setNavVisible(slideCount > 1);
    } else if (!isMobile && !hasInstance) {
      setNavVisible(slideCount > 1);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/slider', () => {
      initMobileSwipers();
    });
  } else {
    initMobileSwipers();
  }
});
window.addEventListener('resize', initMobileSwipers);

const targets = document.querySelectorAll('.news-box__card');
targets.forEach((item) => {
  const btn = item.querySelector('.c-button');

  item.addEventListener('mouseenter', () => {
    btn.classList.add('hover');
  });

  item.addEventListener('mouseleave', () => {
    btn.classList.remove('hover');
  });
});
